<template>
  <div class="black-inputs">
    <el-row>
      <el-col :span="22" :offset="2">
        <el-form ref="dataClientForm" :rules="rulesFormPart1" :model="dataClient.data" label-width="0px">
          <el-row>
            <el-col :span="6">Message d'annulation :</el-col>
            <el-col :span="18">
              <el-form-item prop="resaMessage">
                <el-input v-model="dataClient.data.resaMessage" :autosize="{ minRows: 3 }" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" :offset="1">
        <el-button class="dark" type="primary" @click="closeDialog()">Annuler</el-button>
      </el-col>
      <el-col :span="10" :offset="1">
        <el-button type="primary" @click="sendAnnulation()">Envoyer</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as resaState from '../../store/types/resa-state';
import { sendResaCancelledMessage } from '../../tools/messageSender';
import { formatTimeH, parseTime } from '../../tools/timeTool';

export default {
  name: 'ResaCancelling',
  data() {
    return {
      dataClient: {
        data: {
          resaMessage: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      getClientByid: 'newClients/getClientByid',
      getAllInfos: 'infos/getAllInfos',
      getResaCanceling: 'newReservations/getResaCanceling',
      getCurrentTimestamp: 'calendar/getCurrentTimestamp',
      getSelectedSubService: 'newServices/getSelectedSubService'
    })
  },
  methods: {
    ...mapActions({
      updateClientCount: 'newClients/updateClientCount',
      updateStateResa: 'newReservations/updateStateResa',
      unLinkTables: 'newReservations/unLinkTables',
      unSelectedTables: 'newRooms/unSelectedTables'
    }),
    ...mapMutations({
      setDialogCancelResa: 'displayer/setDialogCancelResa'
    }),
    closeDialog: function () {
      this.setDialogCancelResa(false)
    },
    sendAnnulation: function () {
      this.$refs.dataClientForm.validate((valid) => {
        if (valid) {
          let resa = this.getResaCanceling
          let infoResto = this.getAllInfos
          let client = this.getClientByid(resa.cid)
          let hourFormatted = formatTimeH(parseTime(resa.hour))
          sendResaCancelledMessage({
            clientName: `${client.name} ${client.prenom}`,
            clientEmail: client.email,
            restoName: infoResto.restoName,
            restoEmail: infoResto.restoMail,
            dateResa: `${resa.dateResa.labelDay} ${resa.dateResa.day.toString()} ${resa.dateResa.labelMonth} ${resa.dateResa.year.toString()}`,
            hourResa: hourFormatted,
            message: this.dataClient.data.resaMessage,
            nbCouverts: resa.nbCouvert,
            adresse: infoResto.restoAdresse,
            tel: infoResto.restoTel,
            sendSms: !!this.getAllInfos.clientSmsSended,
            clientTel: client.tel,
            clientTelPreFix: client.telPreFix,
            restoid: infoResto.restoid
          })
          resa.modifyBy = 'RESTAURANT'
          if (this.$router.currentRoute.name === 'PRedirect') resa.modifyBy = 'PERMANENCE'

          this.unLinkTables({ stateResa: resaState.CANCELLED, resa: resa }).then(() => {
            if (resa.ts === undefined) this.updateStateResa({ data: resa, state: resaState.CANCELLED, ts: this.getCurrentTimestamp, service: this.getSelectedSubService })
            else this.updateStateResa({ data: resa, state: resaState.CANCELLED, ts: resa.ts, service: resa.service })
            this.updateClientCount({ cid: resa.cid, type: 'countCancel' })
            this.unSelectedTables()
            this.setDialogCancelResa(false)
          })
        } else {
          return false
        }
      })
    }
  },
  watch: {
    'cid': function (val, oldVal) {
      this.dataClient.data = this.getClientByid(this.cid)
    }
  },
  created: function () {
    if (this.getAllInfos.resaCancelledMessage.length > 0) this.dataClient.data.resaMessage = this.getAllInfos.resaCancelledMessage
    this.rulesFormPart1 = {
      resaMessage: [
        { required: true, message: 'Le message ne peut être vide', trigger: 'blur' }
      ]
    }
  }
}
</script>

<style lang="scss"></style>
